import { createSelector, createFeatureSelector } from "@ngrx/store";
import { IInvestorEntityDetails } from "src/app/models/investor";
import { IInvestorState } from 'src/app/store/state/investor.state';

export const getInvestorState = createFeatureSelector<IInvestorState>('investor');

export const getInvestorEntityDetails = createSelector(
    getInvestorState,
    (state: IInvestorState) => state.details
);

export const getInvestorUpdateStatus = createSelector(
    getInvestorState,
    (state: IInvestorState) => state.investorUpdateStatus
);

export const getInvestorBankDetails = createSelector(
    getInvestorEntityDetails,
    (state: IInvestorEntityDetails) => state.bankAccount
);

export const selectInvestorTaxdetails = createSelector(
    getInvestorEntityDetails,
    (state: IInvestorEntityDetails) => state.taxDetails
);

export const selectCountryTaxResidency = createSelector(
    getInvestorEntityDetails,
    (state: IInvestorEntityDetails) => state.taxDetails.countryTaxResidency
);
export const selectInvestorLegalEntityType = createSelector(
    getInvestorEntityDetails,
    (state: IInvestorEntityDetails) => {
        return state.investorDetails.legalEntityType;
    }
);

export const getInvestorAdvisorInformation = createSelector(
    getInvestorState,
    (state: IInvestorState) => state.advisorInformation
);